<template>
  <div class="rules-page pk-account-panel">
    <section class="rules-hero battle-hero">
      <button class="back-btn" @click="goLucky">返回</button>
      <span>箱子战斗</span>
      <h1>对战规则</h1>
      <p>参与前请确认人数、箱子组合和账户可用余额。创建、加入及结果结算均以房间页面展示为准。</p>
    </section>

    <section class="rules-grid">
      <article v-for="rule in rules" :key="rule.title" class="rule-card">
        <em>{{ rule.num }}</em>
        <strong>{{ rule.title }}</strong>
        <p>{{ rule.text }}</p>
      </article>
    </section>

    <section class="verify-panel">
      <div>
        <span>公平玩法</span>
        <strong>对战结果</strong>
        <p>每场对战根据房间参与者、箱子组合和本局结果完成统计。对战历史可查看已结束房间的相关信息。</p>
      </div>
      <button @click="$router.push({ path: '/zh/battles/history' })">查看对战历史</button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        { num: "01", title: "创建房间", text: "创建对战时可以选择参与人数和箱子组合。房间创建后会进入等待列表，可在对战页查看当前参与状态。" },
        { num: "02", title: "参与费用", text: "加入对战需要支付本场箱子总价。用户中途退出或关闭页面，不会自动撤销已经加入的房间。" },
        { num: "03", title: "回合结算", text: "每个回合会生成本局饰品结果，最终胜负与房间页面的结果说明一致。" },
        { num: "04", title: "奖励归属", text: "赢家获得本场结果对应的奖励。并列或特殊模式以房间公布的结算说明为准。" },
        { num: "05", title: "记录回看", text: "已结束的房间会进入对战历史，可查看房间编号、玩家、箱子、价格和状态。" },
        { num: "06", title: "风险提示", text: "对战会消耗账户余额，请在参与前确认账户、余额和房间状态。" },
      ],
    };
  },
  methods: {
    goLucky() {
      this.$router.push({ path: "/zh/battles" });
    },
  },
};
</script>

<style lang="less" scoped>
.rules-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(143, 103, 255, 0.14), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.rules-hero,
.rules-grid,
.verify-panel {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.rules-hero {
  min-height: 286px;
  padding: 46px 54px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.rules-hero::after {
  content: "";
  width: 780px;
  height: 280px;
  position: absolute;
  right: -170px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.rules-hero span,
.verify-panel span {
  position: relative;
  z-index: 1;
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.rules-hero h1 {
  position: relative;
  z-index: 1;
  margin: 12px 0 14px;
  font-size: 64px;
  line-height: 0.98;
  font-weight: 1000;
}

.rules-hero p {
  position: relative;
  z-index: 1;
  max-width: 760px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.rules-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.rule-card {
  min-height: 182px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 16px 44px rgba(0, 0, 0, 0.22);
}

.rule-card em {
  position: absolute;
  right: 18px;
  top: 10px;
  color: rgba(255, 138, 0, 0.16);
  font-size: 58px;
  font-style: normal;
  font-weight: 1000;
}

.rule-card strong {
  position: relative;
  display: block;
  color: #fff4d8;
  font-size: 22px;
  font-weight: 1000;
}

.rule-card p {
  position: relative;
  margin: 14px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.8;
  font-weight: 800;
}

.verify-panel {
  margin-top: 22px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 18px;
  align-items: center;
  border-radius: 14px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.verify-panel strong {
  display: block;
  margin-top: 8px;
  color: #f7f9ff;
  font-size: 24px;
  font-weight: 1000;
}

.verify-panel p {
  margin: 8px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 800;
}

.verify-panel button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.24);
}

@media screen and (max-width: 980px) {
  .rules-page {
    padding: 20px 12px 64px;
  }

  .rules-hero {
    padding: 72px 24px 34px;
  }

  .rules-hero h1 {
    font-size: 46px;
  }

  .rules-grid,
  .verify-panel {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="less">
body:has(.rules-page) .rules-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 22px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(253, 107, 1, 0.08), transparent 360px),
    #191b26 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero,
body:has(.rules-page) .rules-page.pk-account-panel .rules-grid,
body:has(.rules-page) .rules-page.pk-account-panel .verify-panel {
  width: 100% !important;
  max-width: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero {
  min-height: 224px !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 16% 40%, rgba(255, 132, 31, 0.16), transparent 260px),
    #20222f !important;
  border-color: #2b2d3c !important;
  box-shadow: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-grid {
  gap: 8px !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card,
body:has(.rules-page) .rules-page.pk-account-panel .verify-panel {
  border-radius: 8px !important;
  border-color: #2b2d3c !important;
  background: #20222f !important;
  box-shadow: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card {
  min-height: 156px !important;
}
</style>

<style lang="less">
.rules-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.rules-page.pk-account-panel .rules-hero,
.rules-page.pk-account-panel .rules-grid,
.rules-page.pk-account-panel .verify-panel {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.rules-page.pk-account-panel .rules-hero {
  min-height: 318px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.rules-page.pk-account-panel .rules-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

.rules-page.pk-account-panel .rule-card {
  min-height: 204px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.rules-page.pk-account-panel .verify-panel {
  border-color: rgba(255, 132, 31, 0.18) !important;
}

@media screen and (max-width: 980px) {
  .rules-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .rules-page.pk-account-panel .rules-hero,
  .rules-page.pk-account-panel .rules-grid,
  .rules-page.pk-account-panel .verify-panel {
    width: 100% !important;
  }

  .rules-page.pk-account-panel .rules-grid,
  .rules-page.pk-account-panel .verify-panel {
    grid-template-columns: 1fr !important;
  }
}

body:has(.rules-page) .rules-page.pk-account-panel {
  min-height: calc(100vh - 198px) !important;
  padding: 24px 24px 90px !important;
  background:
    radial-gradient(80% 34% at 50% 0, rgba(236, 216, 184, 0.08), transparent 62%),
    linear-gradient(180deg, #1c1d29 0%, #171923 100%) !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero,
body:has(.rules-page) .rules-page.pk-account-panel .rules-grid,
body:has(.rules-page) .rules-page.pk-account-panel .verify-panel {
  width: min(1540px, calc(100% - 16px)) !important;
  max-width: 1540px !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero {
  min-height: 82px !important;
  padding: 0 20px 0 24px !important;
  display: flex !important;
  align-items: center !important;
  gap: 18px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero::after {
  content: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero span {
  order: 1 !important;
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero h1 {
  order: 2 !important;
  margin: 0 !important;
  color: #f5f7fc !important;
  font-size: 24px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-hero p {
  order: 3 !important;
  max-width: 760px !important;
  margin: 0 !important;
  color: rgba(240, 248, 255, 0.55) !important;
  font-size: 13px !important;
  line-height: 18px !important;
  font-weight: 500 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .back-btn {
  order: 4 !important;
  position: static !important;
  height: 44px !important;
  margin-left: auto !important;
  padding: 0 20px !important;
  color: #ecd8b8 !important;
  background: transparent !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rules-grid {
  margin-top: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 10px !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card {
  min-height: 168px !important;
  padding: 22px 22px 20px !important;
  overflow: hidden !important;
  border: 1px solid rgba(236, 216, 184, 0.08) !important;
  border-radius: 10px !important;
  background:
    radial-gradient(100% 50% at 50% 0, rgba(236, 216, 184, 0.09), rgba(39, 42, 54, 0)),
    linear-gradient(180deg, #21232f, #282a35) !important;
  box-shadow: none !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card::after {
  content: "" !important;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 1px !important;
  background: #ecd8b8 !important;
  opacity: 0.85 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card em {
  right: 16px !important;
  top: 12px !important;
  color: rgba(236, 216, 184, 0.08) !important;
  font-size: 58px !important;
  line-height: 58px !important;
  font-weight: 700 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card strong {
  color: #ecd8b8 !important;
  font-size: 18px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .rule-card p {
  margin-top: 16px !important;
  color: rgba(240, 248, 255, 0.58) !important;
  font-size: 13px !important;
  line-height: 22px !important;
  font-weight: 500 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .verify-panel {
  margin-top: 10px !important;
  padding: 22px 24px !important;
  grid-template-columns: 1fr auto !important;
  border: 1px solid rgba(236, 216, 184, 0.08) !important;
  border-radius: 10px !important;
  background:
    radial-gradient(60% 80% at 92% 0, rgba(253, 107, 1, 0.12), transparent 70%),
    #21232f !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .verify-panel span {
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .verify-panel strong {
  margin-top: 8px !important;
  color: #f5f7fc !important;
  font-size: 20px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .verify-panel p {
  max-width: 860px !important;
  color: rgba(240, 248, 255, 0.58) !important;
  font-size: 13px !important;
  line-height: 22px !important;
  font-weight: 500 !important;
}

body:has(.rules-page) .rules-page.pk-account-panel .verify-panel button {
  height: 44px !important;
  padding: 0 20px !important;
  color: #ecd8b8 !important;
  background: transparent !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

@media screen and (max-width: 980px) {
  body:has(.rules-page) .rules-page.pk-account-panel .rules-hero {
    height: auto !important;
    min-height: 0 !important;
    padding: 16px 0 !important;
    flex-wrap: wrap !important;
  }

  body:has(.rules-page) .rules-page.pk-account-panel .rules-grid,
  body:has(.rules-page) .rules-page.pk-account-panel .verify-panel {
    grid-template-columns: 1fr !important;
  }
}
</style>
